const pt = {
  common: {
    appName: "Letstest",
    panel: "Painel",
    loading: "Carregando",
    pleaseWait: "Aguarde um instante",
    summary: "Resumo",
    visibility: "Visibilidade",
    status: "Situacao",
    creator: "Criador",
    contact: "Contato",
    operations: "Operacoes",
    quickAccess: "Acesso rapido aos modulos do projeto",
    manage: "Gerenciar",
    values: "Valores",
    noComment: "Sem comentario",
    noEnvironment: "Sem ambiente",
    typeLabel: "Tipo",
    brandLabel: "Marca",
    systemLabel: "Sistema",
    nameLabel: "Nome",
    emailLabel: "Email",
    bioLabel: "Bio",
    save: "Salvar",
    add: "Adicionar",
    delete: "Excluir",
    edit: "Editar",
    view: "Visualizar",
    cancel: "Cancelar",
    create: "Criar",
    confirm: "Confirmar",
    close: "Fechar",
    clearFilters: "Limpar filtros",
    customize: "Personalizar",
    viewFile: "Visualizar Arquivo",
    remove: "Remover",
    idLabel: "Id",
    all: "Todos",
    actions: "Acoes",
    createdAction: "criar",
    updatedAction: "alterar",
    createdResult: "criado",
    updatedResult: "alterado",
    openLabel: "Abrir {{label}}",
    templateLabel: "Template",
    environmentLabel: "Ambiente de teste",
    testScenarioLabel: "Cenario de teste",
    testCaseLabel: "Caso de teste",
    executionDeviceLabel: "Dispositivo de execucao",
    selectValue: "Selecione o valor",
    selectTemplate: "Selecione o template",
    selectDevice: "Selecione o dispositivo",
    selectEnvironment: "Selecione o ambiente",
    selectScenario: "Selecione o cenario de testes",
    selectCustomField: "Selecione o campo personalizado",
    columnType: "Tipo da coluna",
    attention: "Atencao!",
    selectTemplateWarning: "Selecione o template desejado para preenchimento.",
    selectDeviceWarning: "Selecione o dispositivo de execucao.",
    processError: "Erro ao processar solicitacao, tente novamente",
    nameRequired: "Nome e obrigatorio",
    emailRequired: "Email e obrigatorio",
    userAvatar: "Avatar do usuario",
    modelLabel: "Modelo",
    osLabel: "Sistema Operacional",
    descriptionLabel: "Descricao",
    typeRequired: "Tipo e obrigatorio",
    brandRequired: "Marca e obrigatoria",
    modelRequired: "Modelo e obrigatorio",
    systemRequired: "Sistema Operacional e obrigatorio",
    descriptionRequired: "Descricao e obrigatoria",
    idRequired: "Id e obrigatorio",
    dueDateLabel: "Prazo",
    selfHosted: "Self-hosted",
    minutesLabel: "Minutos",
    hoursLabel: "Horas",
  },
  commom: {
    continue: "Continuar",
  },
  profile: {
    title: "Perfil",
    viewTitle: "Visualizar Perfil",
    editTitle: "Editar Perfil",
    userInfo: "Informacoes do usuario",
    yourData: "Seus dados",
    mySkills: "Minhas Habilidades",
    myDevices: "Meus Dispositivos",
    updateSkills: "Atualizar competencias e certificacoes",
    manageExecutionEnvironments: "Gerenciar ambientes de execucao",
    updateSuccess: "Perfil alterado com sucesso.",
    updateError: "Erro ao alterar perfil, tente novamente.",
  },
  devices: {
    header: "Dispositivos",
    newTitle: "Novo dispositivo",
    addButton: "Adicionar dispositivo",
    searchLabel: "Buscar por dispositivo",
    searchPlaceholder: "Marca, modelo ou sistema",
    addSuccess: "Dispositivo adicionado com sucesso.",
    addError: "Erro ao adicionar dispositivo, tente novamente",
    deleteSuccess: "Dispositivo excluido com sucesso.",
    deleteError: "Erro ao excluir dispositivo, tente novamente",
    empty: "Nenhum dispositivo encontrado.",
    myTitle: "Meus Dispositivos",
    loadError: "Erro ao carregar dispositivos.",
  },
  habilities: {
    header: "Habilidades",
    newTitle: "Nova habilidade",
    addButton: "Adicionar habilidade",
    searchLabel: "Buscar por habilidade",
    searchPlaceholder: "Buscar por habilidade...",
    addSuccess: "Habilidade adicionada com sucesso.",
    addError: "Erro ao adicionar habilidade, tente novamente",
    descriptionLabel: "Descricao",
    descriptionRequired: "Descricao e obrigatoria",
    deleteSuccess: "Habilidade excluida com sucesso.",
    deleteError: "Erro ao excluir habilidade, tente novamente",
    empty: "Nenhuma habilidade encontrada.",
    myTitle: "Minhas Habilidades",
    loadError: "Erro ao carregar habilidades.",
  },
  reports: {
    averageTitle: "Media das Avaliacoes",
    loadingList: "Carregando avaliacoes da execucao do caso de teste...",
    emptyList: "Nenhuma avaliacao encontrada",
    ratedBy: "Avaliado por",
    situation: "Situacao",
    comment: "Comentario",
    typeLabel: "Tipo",
    scoreLabel: "Nota",
    commentLabel: "Comentario",
    idLabel: "# {{id}}",
    ratedByLabel: "Avaliado por",
    situationLabel: "Situacao",
    commentPrefix: "Comentario: {{comment}}",
    rateTitle: "Avaliar",
    createSuccess: "Avaliacao criada com sucesso",
    createError: "Erro ao criar avaliacao, tente novamente",
    typeRequired: "Tipo e obrigatorio",
    scoreRequired: "Nota e obrigatoria",
    commentRequired: "Comentario e obrigatorio",
    listTitle: "Avaliacoes da execucao # {{id}}",
    searchLabel: "Buscar por comentario",
    searchPlaceholder: "Buscar por comentario...",
    loadError: "Erro ao carregar avaliacoes",
  },
  projectOverview: {
    pageTitle: "Visao Geral",
    testScenariosTitle: "Cenarios de Teste",
    reportTitle: "Relatorio do projeto",
    issuedOn: "Emitido em {{date}}",
    total: "Total: {{total}}",
    scenarioLabel: "Cenario {{index}}",
    caseLabel: "Caso {{index}}",
    executionLabel: "Execucao {{index}} · #{{id}}",
    loadError: "Erro ao carregar o projeto.",
    exportPdf: "Exportar como PDF",
  },
  templates: {
    selectType: "Selecione o tipo do template",
    definitionLegend: "Definicao do Template",
    viewTitle: "Visualizar Template",
    editTitle: "Personalizar Template",
    minRowRequired: "Necessario ao menos uma linha para confirmacao.",
    createSuccess: "Template criado com sucesso",
    createError: "Erro ao criar template, tente novamente",
    listTitle: "Templates",
    loadError: "Erro ao carregar templates.",
    searchLabel: "Buscar por nome",
    searchPlaceholder: "Buscar por nome...",
    createNew: "Criar novo",
    loadingList: "Carregando templates do projeto...",
    emptyList: "Nenhum template encontrado",
  },
  tags: {
    activeGroup: "Ativos",
    archivedGroup: "Arquivados",
    addValue: "Adicionar Valor",
    formTitle: "Campo Personalizado",
    minValueRequired: "Necessario ao menos um valor criado.",
    saveSuccess: "Campo personalizado {{action}} com sucesso",
    saveError: "Erro ao {{action}} Campo Personalizado, tente novamente",
    unexpectedError: "Erro inesperado",
    commentLabel: "Comentario",
    visibilityLabel: "Visibilidade",
    visibilityRequired: "Situacao e obrigatoria",
    selectSituation: "Selecione a situacao do campo personalizado",
    helpCommentaryLabel: "Comentario de ajuda",
    listTitle: "Campos Personalizados",
    loadError: "Erro ao carregar campos personalizados.",
    searchLabel: "Buscar por nome",
    searchPlaceholder: "Buscar por nome...",
    createNew: "Criar novo",
    loadingList: "Carregando campos personalizados do projeto...",
    emptyList: "Nenhum campo personalizado encontrado",
  },
  environment: {
    listTitle: "Ambientes de Teste",
    loadError: "Erro ao carregar ambiente de teste.",
    searchLabel: "Buscar por nome",
    searchPlaceholder: "Buscar por nome...",
    createNew: "Criar novo",
    loadingList: "Carregando ambientes de teste do projeto...",
    emptyList: "Nenhum ambiente de teste encontrado",
    formEditTitle: "Edicao",
    formCreateTitle: "Cadastro",
    saveChanges: "Salvar alteracoes",
    createEnvironment: "Criar ambiente",
    updateSuccess: "Ambiente alterado com sucesso",
    updateError: "Erro ao alterar ambiente, tente novamente",
    createSuccess: "Ambiente criado com sucesso",
    createError: "Erro ao criar ambiente, tente novamente",
    situationRequired: "Situacao e obrigatoria",
    descriptionLabel: "Descricao/Acesso",
    descriptionRequired: "Descricao/Acesso e obrigatoria",
  },
  testScenario: {
    listTitle: "Cenarios de Teste",
    definitionLegend: "Definicao do Cenario de Teste:",
    pageTitle: "Cenario de Teste",
    noTemplatesInfo: "Nao ha nenhum template para Definicao de cenarios de teste para o seu projeto, certifique-se de criar ao menos.",
    minRowRequired: "Necessario ao menos uma linha para confirmacao.",
    saveSuccess: "Cenario de teste {{action}} com sucesso",
    saveError: "Erro ao {{action}} Cenario de teste, tente novamente",
    unexpectedError: "Erro inesperado",
    templateRequired: "Template e obrigatorio",
    loadError: "Erro ao carregar cenarios de teste.",
    searchLabel: "Buscar por nome",
    searchPlaceholder: "Buscar por nome...",
    createNew: "Criar novo",
    loadingList: "Carregando cenarios de teste do projeto...",
    emptyList: "Nenhum cenario de teste encontrado",
    lockedByExecution: "Este cenario possui execucoes e nao pode ser editado.",
    viewCases: "Ver casos",
    approveAction: "Aprovar",
  },
  testCase: {
    listTitle: "Casos de Teste",
    definitionLegend: "Definicao do Caso de Teste:",
    pageTitle: "Caso de Teste",
    noTemplatesInfo: "Nao ha nenhum template para Definicao de casos de teste para o seu projeto, certifique-se de criar ao menos.",
    minRowRequired: "Necessario ao menos uma linha para confirmacao.",
    saveSuccess: "Caso de teste {{action}} com sucesso",
    saveError: "Erro ao {{action}} Caso de teste, tente novamente",
    unexpectedError: "Erro inesperado",
    environmentRequired: "Ambiente de teste e obrigatorio",
    testScenarioRequired: "Cenario de teste e obrigatorio",
    templateRequired: "Template e obrigatorio",
    loadError: "Erro ao carregar casos de teste.",
    searchLabel: "Buscar por nome",
    searchPlaceholder: "Buscar por nome...",
    testerFilterLabel: "Filtrar por testador",
    createNew: "Criar novo",
    loadingList: "Carregando casos de teste do projeto...",
    emptyList: "Nenhum caso de teste encontrado",
    scenarioButton: "Cenario",
    executionsButton: "Execucoes",
    testButton: "Testar",
    noScenario: "Sem cenario",
    lockedByExecution: "Este caso possui execucoes e nao pode ser editado.",
    assignAction: "Designar testadores",
    assignTitle: "Designar testadores",
    assignHelp: "Escolha os testadores que vao executar este caso.",
    assignSearchLabel: "Buscar testador",
    assignSearchPlaceholder: "Nome ou e-mail",
    assignConfirm: "Confirmar designacao",
    assignSuccess: "Testadores designados com sucesso",
    assignError: "Erro ao designar testadores, tente novamente",
    assignLoadError: "Erro ao carregar testadores",
    assignEmpty: "Nenhum testador encontrado",
    awaitingAssignment: "Aguardando envio para teste",
    assignedStatus: "Designado",
    viewAssignment: "Ver designacao",
    openExecutionButton: "Executar",
    statusFilterLabel: "Status da execucao",
    statusIdle: "Nao iniciado",
    statusRunning: "Em andamento",
    statusPaused: "Em pausa",
    statusFinished: "Finalizado",
    viewList: "Lista",
    viewKanban: "Kanban",
    emptyStatusColumn: "Nenhum caso nesse status",
    kanbanUnassigned: "Sem atribuicao",
    kanbanNotStarted: "Nao iniciado",
    kanbanInProgress: "Em andamento",
    kanbanPaused: "Pausado",
    kanbanDone: "Finalizado",
    kanbanEmpty: "Nenhum caso",
    startTestButton: "Iniciar teste",
    pauseTestButton: "Pausar",
    pauseTestConfirm: "Deseja pausar o andamento deste teste?",
    pauseTestSuccess: "Teste pausado com sucesso.",
    resumeTestButton: "Retomar",
    reportTestButton: "Reportar teste",
    startTestError: "Erro ao iniciar teste, tente novamente.",
    pauseTestError: "Erro ao pausar teste, tente novamente.",
    resumeTestError: "Erro ao retomar teste, tente novamente.",
  },
  testExecution: {
    sessionTitle: "Executar caso de teste",
    elapsedLabel: "Tempo ate agora: {{time}}",
    startSuccess: "Teste iniciado com sucesso.",
    pauseSuccess: "Teste pausado com sucesso.",
    resumeSuccess: "Teste retomado com sucesso.",
    finishSuccess: "Teste finalizado, prossiga com o report.",
    reportLegend: "Reportar execucao do Caso de Teste:",
    pageTitle: "Testar Caso de Teste",
    executeTitle: "Executar caso de teste",
    testCaseRequired: "Caso de teste e obrigatorio",
    deviceRequired: "Dispositivo e obrigatorio",
    templateRequired: "Template e obrigatorio",
    reportButton: "Reportar Execucao",
    noTemplatesInfo: "Nao ha nenhum template para Execucao de casos de teste para o seu projeto, certifique-se de criar ao menos.",
    reportSuccess: "Execucao reportada com sucesso.",
    reportError: "Erro ao reportar execucao, tente novamente.",
    listTitle: "Execucoes do Caso de Teste #{{id}}",
    loadError: "Erro ao carregar execucoes do caso de teste: {{error}}",
    searchLabel: "Buscar por #",
    searchPlaceholder: "Buscar por #...",
    loadingList: "Carregando execucoes do caso de testes...",
    emptyList: "Nenhuma execucao para o caso de teste encontrada",
    testedByLabel: "Testado por",
    executionTimeLabel: "Tempo de execucao",
    executionTimeHint: "Sugerido: {{time}} (voce pode ajustar)",
    executionTimePlaceholder: "Ex: 1:15",
    executionTimeFormatHint: "Formato: H:MM (horas:minutos) ou minutos",
    executionTimeInvalid: "Informe um tempo valido. Ex: 1:15 ou 45",
    startError: "Erro ao iniciar teste, tente novamente.",
    pauseError: "Erro ao pausar teste, tente novamente.",
    resumeError: "Erro ao retomar teste, tente novamente.",
    finishError: "Erro ao finalizar teste, tente novamente.",
    deviceLabel: "Dispositivo",
    evaluateButton: "Avaliar",
    ratingsButton: "Avaliacoes",
  },
  fileUpload: {
    uploading: "Enviando arquivo {{current}} de {{total}}...",
    uploadedSuccess: "Arquivos enviados com sucesso:",
    uploadError: "Erro ao enviar arquivo: {{error}}",
  },
  timer: {
    elapsed: "Tempo decorrido: {{time}}",
    continue: "Continuar",
    start: "Inicializar",
    finish: "Finalizar",
    pause: "Pausar",
    resume: "Retomar",
    reset: "Reiniciar",
    recordScreen: "Gravar Tela",
    recordError: "Erro ao iniciar a gravacao:",
  },
  customTable: {
    editColumnTitle: "Editar Coluna",
    contentPlaceholder: "Conteudo",
    helpTextPlaceholder: "Texto de Ajuda",
    loadTagsError: "Erro ao carregar tags:",
    typeLabel: "Tipo de coluna",
    contentLabel: "Conteudo",
    placeholderLabel: "Texto de ajuda",
    tagLabel: "Campo personalizado",
    typeHelpTitle: "Dica rapida",
    typeHelpDescription: "Escolha o tipo certo para organizar o preenchimento e a leitura.",
    previewLabel: "Pre-visualizacao",
    previewHint: "Apenas uma pre-visualizacao do campo.",
    addRow: "Adicionar Linha",
    addColumn: "Adicionar Coluna",
    duplicateRow: "Duplicar linha",
    removeRow: "Remover linha",
    duplicateColumn: "Duplicar coluna",
    removeColumn: "Remover coluna",
    editColumn: "Editar coluna",
    editLabelDefault: "Editar Label",
    columnLabel: "Coluna {{index}}",
    fillPlaceholder: "Preencha o campo",
    emptyValue: "Sem valor",
    maxColumnsInfo: "Linha nao pode ter mais de {{count}} coluna(s)",
    minColumnsInfo: "Linha precisa ter ao menos {{count}} coluna(s)",
    minRowRequired: "Necessario ao menos uma linha",
    columnTypes: {
      label: "Label",
      text: "Texto curto",
      longText: "Texto longo",
      tag: "Campo personalizado",
      list: "Lista",
      table: "Tabela",
      empty: "Espaco",
      file: "Arquivo",
      multipleFiles: "Multiplos arquivos",
    },
  },
  involvement: {
    acceptError: "Erro ao aceitar envolvimento com o projeto.",
    rejectError: "Erro ao rejeitar envolvimento com o projeto.",
    removeError: "Erro ao remover envolvimento com o projeto.",
    addMember: "Adicionar membro",
    addMemberTitle: "Vincular membro ao projeto",
    addMemberHelp: "Selecione membros da organizacao para vincular ao projeto.",
    addAction: "Adicionar",
    loadMembersError: "Erro ao carregar membros da organizacao.",
    addSuccess: "Membro vinculado com sucesso.",
    addError: "Erro ao vincular membro.",
    emptyMembers: "Nenhum membro disponivel para vincular.",
    creatorLabel: "Criador",
    accept: "Aceitar",
    reject: "Rejeitar",
    cancelRequest: "Cancelar solicitacao",
    pendingTitle: "Solicitacoes e Convites",
    loadError: "Erro ao carregar envolvimentos.",
    invitationsTitle: "Convites Recebidos",
    invitationsHelp: "Convites enviados a voce pelos gerentes de projetos",
    invitationsLoadError: "Erro ao carregar convites.",
    requestsTitle: "Solicitacoes Enviadas",
    requestsHelp: "Solicitacoes de participacao enviadas por voce",
    requestsLoadError: "Erro ao carregar solicitacoes.",
    emptyList: "Nenhum envolvimento encontrado.",
    ownerLoadError: "Erro ao carregar envolvimentos.",
    inviteEmailLabel: "Convidar por e-mail",
    inviteEmailTitle: "Convidar por e-mail",
    inviteEmailHelp: "Informe o e-mail do usuario para enviar o convite.",
    inviteByEmail: "Convidar por e-mail",
    inviteSearch: "Procurar usuarios",
    invitePlaceholder: "E-mail do usuario para convite",
    inviteMissingEmail: "Preencha o e-mail para enviar o convite.",
    inviteSuccess: "Convite enviado.",
    inviteError: "Erro ao enviar convite.",
    inviteButton: "Convidar",
    inviteModalTitle: "Convidar usuario",
    inviteModalHelp: "Busque por nome, e-mail, habilidades ou dispositivos para enviar convites.",
    inviteSearchError: "Erro ao buscar usuarios.",
    searchLabel: "Buscar usuario",
    searchPlaceholder: "Nome ou e-mail",
    habilityLabel: "Habilidade",
    habilityPlaceholder: "Ex: Cypress, QA, Ingles",
    habilityTypeLabel: "Tipo de habilidade",
    deviceTypeLabel: "Tipo de dispositivo",
    deviceBrandLabel: "Marca do dispositivo",
    deviceBrandPlaceholder: "Ex: Apple, Samsung",
    deviceModelLabel: "Modelo do dispositivo",
    deviceModelPlaceholder: "Ex: iPhone 14, Galaxy S23",
    deviceSystemLabel: "Sistema do dispositivo",
    deviceSystemPlaceholder: "Ex: iOS, Android, Windows",
    searchResults: "Resultados da busca",
    emptySearch: "Nenhum usuario encontrado com esses filtros.",
    loadingList: "Carregando envolvimentos...",
    emptyReceived: "Nenhuma candidatura recebida",
    emptyForSituation: "Nenhum envolvimento com o projeto para a situacao selecionada",
    viewProfile: "Ver perfil",
  },
  nav: {
    dashboard: "Dashboard",
    findProjects: "Encontrar projetos",
    manageProjects: "Gerenciar projetos",
    testProjects: "Testar projetos",
    billing: "Billing",
    apiKeys: "API Keys",
    webhooks: "Webhooks",
    admin: "Administracao",
    adminSubscriptions: "Assinaturas",
    myOrganizations: "Minhas organizacoes",
    requestsInvites: "Solicitacoes e convites",
    invitations: "Convites recebidos",
    requests: "Solicitacoes enviadas",
    orgInvites: "Convites de organizacao",
    myProfile: "Meu perfil",
    notifications: "Notificacoes",
    notificationsEmpty: "Voce nao tem notificacoes",
    viewAllNotifications: "Ver todas as notificacoes",
    tools: "Ferramentas",
    toolsRecordScreen: "Gravar tela",
    toolsRecordingStarted: "Gravacao iniciada.",
    toolsRecordingError: "Erro ao iniciar gravacao.",
    toolsChecklist: "Checklist rapido",
    toolsChecklistTitle: "Checklist rapido",
    toolsChecklistPlaceholder: "Adicionar item (ex: validar dados)",
    toolsChecklistAdd: "Adicionar",
    toolsChecklistEmpty: "Nenhum item no checklist.",
    toolsChecklistDefaultEnvironment: "Confirmar ambiente de teste",
    toolsChecklistDefaultScenario: "Revisar cenario e passos",
    toolsChecklistDefaultData: "Validar dados de entrada",
    toolsChecklistDefaultEvidence: "Capturar evidencias",
    toolsChecklistDefaultNotes: "Registrar observacoes",
    markAllRead: "Marcar tudo como lido",
    logout: "Sair",
    logoutSuccess: "Usuario deslogado",
  },
  projects: {
    operationsTitle: "Operacoes",
    operationsSubtitle: "Acesso rapido aos modulos do projeto",
    managersLabel: "Gerentes",
    testersLabel: "Testadores",
    testScenariosLabel: "Cenarios de Teste",
    testCasesLabel: "Casos de Teste",
    customFieldsLabel: "Campos Personalizados",
    templatesLabel: "Templates",
    environmentsLabel: "Ambientes",
    overviewLabel: "Visao Geral",
    notificationsLabel: "Notificacoes",
    loadError: "Erro ao carregar o projeto.",
    detailTitle: "Detalhes do Projeto",
    ownerTitle: "Gerenciar Projetos",
    ownerHelp: "Projetos que voce e responsavel pelo gerenciamento",
    testerTitle: "Testar Projetos",
    testerHelp: "Projetos que voce e responsavel pelos testes",
    searchLabel: "Buscar por nome",
    searchPlaceholder: "Buscar por nome...",
    createNew: "Criar novo",
    loadingOwnerList: "Carregando seus projetos...",
    emptyOwnerList: "Nenhum projeto encontrado",
    editAria: "Editar projeto",
    roleOwner: "Dono",
    roleManager: "Gerente",
    loadListError: "Erro ao carregar projetos.",
    formEditTitle: "Edicao",
    formCreateTitle: "Cadastro",
    saveChanges: "Salvar alteracoes",
    createProject: "Criar projeto",
    updateSuccess: "Projeto alterado com sucesso",
    updateError: "Erro ao alterar projeto, tente novamente",
    createSuccess: "Projeto criado com sucesso",
    createError: "Erro ao criar projeto, tente novamente",
    processError: "Erro ao processar solicitacao, tente novamente",
    approvalTitle: "Workflow de aprovacao",
    approvalEnabled: "Ativar aprovacao de artefatos",
    approvalScenarioEnabled: "Exigir aprovacao para cenarios de teste",
    approvalTestCaseEnabled: "Exigir aprovacao para casos de teste",
    visibilityRequired: "Visibilidade e obrigatoria",
    visibilityPlaceholder: "Selecione a visibilidade do projeto",
    public: {
      title: "Encontrar projetos",
      help: "Encontre projetos publicos e solicite a participacao como testador",
      createProject: "Criar meu projeto",
      invitations: "Convites recebidos",
      requests: "Solicitacoes enviadas",
      searchPlaceholder: "Buscar por nome...",
      loading: "Carregando seus projetos...",
      empty: "Nenhum projeto encontrado",
      apply: "Solicitar participacao",
      applySuccess: "Solicitacao de participacao enviada",
      applyError: "Erro ao enviar solicitacao, tente novamente",
      loadError: "Erro ao carregar projetos",
      creatorLabel: "Criador",
    },
  },
  notifications: {
    settingsTitle: "Configuracoes de notificacao",
    settingsSaved: "Configuracoes salvas com sucesso.",
    settingsError: "Erro ao salvar configuracoes.",
    listTitle: "Notificacoes",
    filterAll: "Todas",
    filterUnread: "Nao lidas",
    emptyList: "Nenhuma notificacao encontrada",
    markRead: "Marcar como lida",
    channelsTitle: "Canais",
    channelInApp: "Notificacao no sistema",
    channelEmail: "Notificacao por e-mail",
    eventsTitle: "Eventos criticos",
    executionRejected: "Execucao reprovada",
    inviteReceived: "Convite recebido",
    inviteAccepted: "Convite aceito",
    deadlineExceeded: "Prazo estourado",
    deadlineConfigTitle: "Alertas de prazo",
    deadlineWarning: "Avisar antes do prazo",
    deadlineWarningDays: "Dias de antecedencia",
  },
  billing: {
    title: "Billing",
    subtitle: "Gerencie sua assinatura e uso.",
    settingsHelp: "Revise assinatura e limites.",
    currentPlan: "Plano atual",
    changePlan: "Trocar plano",
    manageBilling: "Gerenciar billing",
    plansTitle: "Planos",
    plansSubtitle: "Escolha o melhor plano para sua organizacao.",
    planFree: "Free",
    plan_free: "Free",
    plan_pro: "Pro",
    plan_enterprise: "Enterprise",
    freePrice: "Gratis",
    priceMonthly: "R$ {{value}} / mes",
    choosePlan: "Escolher plano",
    loadError: "Erro ao carregar dados de billing.",
    checkoutError: "Erro ao iniciar checkout.",
    portalError: "Erro ao abrir portal de billing.",
    disabled: "Billing esta desabilitado neste ambiente.",
    usageTitle: "Uso e limites",
    unlimited: "Ilimitado",
    apiAccess: "Acesso API",
    apiNoAccess: "Sem acesso API",
    webhooksCount: "{{count}} webhooks",
    webhooksUnlimited: "Webhooks ilimitados",
    auditLogsDays: "Audit logs: {{count}} dias",
    auditLogsUnlimited: "Audit logs: ilimitado",
    metricSeats: "Membros",
    metricProjects: "Projetos",
    metricTestCases: "Casos de teste",
    metricStorage: "Armazenamento",
    metricExecutions: "Execucoes de teste",
    limitTitle: "Limite atingido",
    limitSubtitle: "Faca upgrade para continuar",
    limitDescription: "Voce atingiu um limite do plano para esta acao.",
    limitMetric: "{{metric}}: {{current}} / {{limit}}",
    limitIncludesInvites: "Inclui convites pendentes: {{pending}}",
    upgradeAction: "Ver planos",
    successTitle: "Pagamento confirmado",
    successSubtitle: "Seu plano foi atualizado.",
    backToBilling: "Voltar ao billing",
  },
  apiKeys: {
    title: "API Keys",
    subtitle: "Gerencie as chaves de acesso a API publica.",
    listTitle: "Suas API Keys",
    create: "Criar API Key",
    empty: "Nenhuma API key criada.",
    nameRequired: "Nome e obrigatorio.",
    createSuccess: "API key criada com sucesso.",
    createError: "Erro ao criar API key.",
    deleteSuccess: "API key removida com sucesso.",
    deleteError: "Erro ao remover API key.",
    confirmDelete: "Tem certeza que deseja remover esta API key?",
    loadError: "Erro ao carregar API keys.",
    noAccess: "Acesso a API nao disponivel no seu plano.",
    copied: "Copiado para a area de transferencia.",
    newKey: "Nova API Key",
    keyCreated: "API Key Criada",
    createTitle: "Criar nova API Key",
    copyWarning: "Copie a chave abaixo. Ela nao sera exibida novamente.",
    nameLabel: "Nome",
    namePlaceholder: "Ex: Integracao CI/CD",
    scopesLabel: "Permissoes",
    expiresLabel: "Expiracao (opcional)",
    expiresHint: "Deixe em branco para nao expirar.",
    lastUsed: "Ultimo uso: {{date}}",
    neverUsed: "Nunca utilizada",
  },
  webhooks: {
    title: "Webhooks",
    subtitle: "Configure notificacoes para eventos do sistema.",
    listTitle: "Seus Webhooks",
    create: "Criar Webhook",
    empty: "Nenhum webhook configurado.",
    urlRequired: "URL e obrigatoria.",
    eventsRequired: "Selecione ao menos um evento.",
    createSuccess: "Webhook criado com sucesso.",
    createError: "Erro ao criar webhook.",
    deleteSuccess: "Webhook removido com sucesso.",
    deleteError: "Erro ao remover webhook.",
    updateSuccess: "Webhook atualizado com sucesso.",
    updateError: "Erro ao atualizar webhook.",
    confirmDelete: "Tem certeza que deseja remover este webhook?",
    loadError: "Erro ao carregar webhooks.",
    noAccess: "Webhooks nao disponiveis no seu plano.",
    copied: "Copiado para a area de transferencia.",
    newWebhook: "Novo Webhook",
    webhookCreated: "Webhook Criado",
    createTitle: "Criar novo Webhook",
    copyWarning: "Copie o secret abaixo. Ele nao sera exibido novamente.",
    urlLabel: "URL de destino",
    eventsLabel: "Eventos",
    active: "Ativo",
    inactive: "Inativo",
    enable: "Ativar",
    disable: "Desativar",
    regenerate: "Regenerar secret",
    confirmRegenerate: "Tem certeza que deseja regenerar o secret? O secret anterior sera invalidado.",
    regenerateSuccess: "Secret regenerado e copiado.",
    regenerateError: "Erro ao regenerar secret.",
    viewDeliveries: "Ver entregas",
    recentDeliveries: "Entregas recentes",
    noDeliveries: "Nenhuma entrega registrada.",
    deliveriesError: "Erro ao carregar entregas.",
    limit: "{{current}} de {{max}} webhooks",
    events: {
      "test_execution.created": "Execucao de teste criada",
      "test_execution.reported": "Execucao de teste reportada",
      "report.created": "Relatorio criado",
      "test_case.created": "Caso de teste criado",
      "test_case.updated": "Caso de teste atualizado",
      "test_scenario.created": "Cenario de teste criado",
      "involvement.accepted": "Convite aceito",
    },
  },
  dashboard: {
    pageTitle: "Dashboard",
    filtersTitle: "Filtros globais",
    filtersSubtitle: "Refine os indicadores do projeto",
    keyMetricsTitle: "Metricas principais",
    executedCases: "Casos executados",
    coverageRate: "Cobertura de casos",
    pendingReports: "Relatorios pendentes",
    lastActivity: "Ultima atividade",
    lastActivityEmpty: "Sem registros",
    qualitySignalTitle: "Sinal de qualidade",
    qualitySignalLabel: "Nivel de reprovas",
    qualitySignal: {
      low: "Baixo",
      medium: "Moderado",
      high: "Alto",
    },
    qualitySignalValue: "{{value}}% de reprovas",
    actionItemsTitle: "Acoes prioritarias",
    actionItemsEmpty: "Nenhuma acao critica agora",
    actionPendingReports: "{{count}} execucoes aguardando avaliacao",
    actionLowCoverage: "Cobertura abaixo do ideal ({{rate}}%)",
    actionHotspot: "Cenario critico: {{name}} ({{rate}}% falhas)",
    actionNoExecutions: "Sem execucoes no periodo selecionado",
    actionNoReviews: "Nenhuma avaliacao registrada ainda",
    projectLabel: "Projeto",
    scenarioLabel: "Cenario",
    testerLabel: "Testador",
    statusLabel: "Status",
    statusApproved: "Aprovado",
    statusRejected: "Reprovado",
    emptyProjects: "Nenhum projeto disponivel",
    overviewTitle: "Visao geral do projeto",
    totalScenarios: "Total de cenarios",
    totalManagers: "Total de gerentes",
    totalTesters: "Total de testadores",
    totalCases: "Total de casos",
    totalExecutions: "Total de execucoes",
    totalReports: "Total de avaliacoes",
    approvalRate: "Taxa de aprovacao",
    approvals: "Aprovacoes",
    rejections: "Reprovacoes",
    averageScore: "Media de notas",
    rankingTitle: "Ranking de testadores",
    topLabel: "Top 5",
    emptyRanking: "Sem dados suficientes para ranking",
    failureRateTitle: "Taxa de falhas por cenario",
    failureRateLabel: "falhas",
    emptyScenarios: "Nenhum cenario encontrado",
    unknownTester: "Testador",
    dailyExecutionsTitle: "Execucoes por dia",
    dailyExecutionsSubtitle: "Execucoes reportadas pelos testadores",
    periodLabel: "Periodo",
    lastDays: "Ultimos {{count}} dias",
    chartSummary: "Resumo do grafico",
    averagePerDay: "Media por dia",
    averagePerDayProject: "Media por dia (projeto)",
    executionsLabel: "execucoes",
    customRange: "Intervalo personalizado",
    startDateLabel: "Data inicial",
    endDateLabel: "Data final",
    invalidRange: "Periodo invalido",
    startDateBeforeProject: "Data inicial nao pode ser menor que a criacao do projeto",
    managerProjects: "Meus projetos",
    testerProjects: "Projetos testados",
    myOverviewTitle: "Visao geral do meu trabalho",
    myPerformanceTitle: "Meu desempenho",
    myExecutions: "Minhas execucoes",
    myApprovals: "Minhas aprovacoes",
    myRejections: "Minhas reprovacoes",
    myAverageScore: "Minha media de notas",
    failureRateMineTitle: "Taxa de falhas nos meus testes",
  },
  enums: {
    device: {
      smartphone: "Smartphone",
      notebook: "Notebook",
      desktop: "Desktop",
      tablet: "Tablet",
      smartwatch: "Smartwatch",
    },
    project: {
      visibility: {
        public: "Publico",
        private: "Privado",
      },
      situation: {
        testing: "Em teste",
        finished: "Finalizado",
        canceled: "Cancelado",
      },
      type: {
        web: "Web",
        desktop: "Desktop",
        app: "App",
        hybrid: "Hibrido",
      },
    },
    involvement: {
      situation: {
        received: "Recebido",
        sent: "Enviado",
        rejected: "Rejeitado",
        accepted: "Aceito",
      },
      type: {
        tester: "Testador",
        manager: "Gerente",
      },
    },
    template: {
      type: {
        testScenarioDefinition: "Definicao de cenarios de teste",
        testCaseDefinition: "Definicao de casos de teste",
        testCaseExecution: "Execucao de casos de teste",
      },
    },
    report: {
      type: {
        approved: "Aprovado",
        rejected: "Rejeitado",
      },
    },
    hability: {
      type: {
        experience: "Experiencia",
        certification: "Certificacao",
        course: "Curso",
        language: "Linguagem",
        softSkill: "Soft Skill",
      },
    },
    environment: {
      situation: {
        operational: "Operante",
        inoperative: "Inoperante",
      },
    },
  },
  approval: {
    draft: "Rascunho",
    reviewed: "Revisado",
    approved: "Aprovado",
  },
  auth: {
    loginTitle: "Acesse sua conta",
    loginSubtitle: "Organize seus testes com fluxo claro e rastreavel.",
    loginTag1: "Testes de software",
    loginTag2: "Fluxo guiado",
    loginTag3: "Relatorios claros",
    loginButton: "Entrar",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Senha",
    noAccount: "Ainda nao possui uma conta?",
    createAccount: "Crie agora",
    registerTitle: "Crie sua conta",
    registerSubtitle: "Comece a estruturar seus projetos em minutos.",
    registerTag1: "Times conectados",
    registerTag2: "Templates prontos",
    registerTag3: "Metricas visiveis",
    registerButton: "Criar conta",
    namePlaceholder: "Seu nome completo",
    organizationName: "Nome da Organizacao",
    organizationNamePlaceholder: "Ex: Minha Empresa",
    confirmPassword: "Confirmar senha",
    alreadyHaveAccount: "Ja tem uma conta?",
    signInHere: "Faca login aqui",
    loginSuccess: "Login realizado com sucesso",
    loginError: "Erro ao realizar login",
    registerSuccess: "Conta criada com sucesso",
    registerError: "Erro ao se registrar, tente novamente",
    passwordMismatch: "Senhas nao coincidem",
    emailAlreadyExists: "Este email ja esta cadastrado",
    forgotPassword: "Esqueci minha senha",
    forgotPasswordTitle: "Redefina sua senha",
    forgotPasswordSubtitle: "Vamos enviar um link seguro para o seu email.",
    sendResetLink: "Enviar link",
    backToLogin: "Voltar para o login",
    resetEmailSent: "Se o email existir, enviaremos um link de redefinicao",
    resetEmailError: "Erro ao enviar email de redefinicao",
    resetTitle: "Crie uma nova senha",
    resetSubtitle: "Defina uma senha segura para continuar.",
    resetButton: "Redefinir senha",
    resetSuccess: "Senha redefinida com sucesso",
    resetError: "Erro ao redefinir senha",
    resetTokenMissing: "Token de redefinicao nao encontrado",
  },
  onboarding: {
    stepLabel: "Passo {{step}} de {{total}}",
    welcome: "Vamos concluir a configuracao inicial.",
    orgSetupTitle: "Defina sua organizacao",
    orgSetupSubtitle: "Escolha um nome claro e um identificador unico.",
    orgSetupSuccess: "Organizacao atualizada com sucesso",
    orgSetupError: "Erro ao atualizar organizacao",
    teamStep: "Convide seu time (opcional)",
    inviteTitle: "Convide pessoas para colaborar",
    inviteSubtitle: "Adicione emails e enviaremos convites imediatamente.",
    inviteEmailLabel: "Email do colaborador",
    inviteEmailPlaceholder: "email@empresa.com",
    addInvite: "Adicionar",
    inviteSuccess: "Convites enviados com sucesso",
    inviteError: "Erro ao enviar convites",
    invalidEmail: "Email invalido",
    emailAlreadyAdded: "Email ja adicionado",
    projectStep: "Crie seu primeiro projeto",
    projectTitle: "Primeiro projeto",
    projectSubtitle: "Crie um projeto para organizar seus testes.",
    projectSuccess: "Projeto criado com sucesso",
    projectError: "Erro ao criar projeto",
    finishSetup: "Finalizar configuracao",
    skipStep: "Pular etapa",
    skipToDashboard: "Ir para o dashboard",
  },
  organization: {
    settings: "Configuracoes",
    settingsDescription: "Gerencie as configuracoes da sua organizacao",
    members: "Membros",
    membersDescription: "Gerencie os membros da sua organizacao",
    listTitle: "Minhas Organizacoes",
    listHelp: "Organizacoes que voce participa ou administra",
    searchLabel: "Buscar por nome",
    searchPlaceholder: "Buscar por nome...",
    loadingList: "Carregando suas organizacoes...",
    emptyList: "Nenhuma organizacao encontrada",
    roleOwner: "Proprietario",
    roleAdmin: "Administrador",
    roleMember: "Membro",
    name: "Nome da Organizacao",
    namePlaceholder: "Ex: Minha Empresa",
    slug: "Identificador (Slug)",
    slugReadonly: "O identificador nao pode ser alterado",
    plan: "Plano",
    createNew: "Criar nova",
    createNewTitle: "Criar organizacao",
    createSuccess: "Organizacao criada com sucesso",
    createError: "Erro ao criar organizacao",
    limitReached: "Limite de organizacoes atingido",
    updateSuccess: "Organizacao atualizada com sucesso",
    updateError: "Erro ao atualizar organizacao",
    noOrganization: "Nenhuma organizacao selecionada",
    accessDenied: "Voce nao tem permissao para acessar esta pagina",
    switchOrg: "Trocar organizacao",
    switchError: "Erro ao trocar organizacao",
    loadMembersError: "Erro ao carregar membros",
    noMembers: "Nenhum membro encontrado",
    activeMembers: "Membros ativos",
    memberName: "Nome",
    memberEmail: "Email",
    memberRole: "Funcao",
    you: "voce",
    editRole: "Editar funcao",
    removeMember: "Remover membro",
    confirmRemove: "Tem certeza que deseja remover {{name}} da organizacao?",
    memberRemoved: "Membro removido com sucesso",
    removeError: "Erro ao remover membro",
    roleUpdated: "Funcao atualizada com sucesso",
    roleUpdateError: "Erro ao atualizar funcao",
    inviteMember: "Convidar membro",
    invite: "Convite",
    inviteEmail: "Email do convidado",
    inviteRole: "Funcao do convidado",
    sendInvite: "Enviar convite",
    inviteSent: "Convite enviado com sucesso",
    inviteError: "Erro ao enviar convite",
    inviteHint: "Se o email ja possui conta no sistema, o usuario podera aceitar o convite diretamente. Caso contrario, sera enviado um email de convite.",
    inviteCreatedUserExists: "Convite criado! O usuario pode aceitar pelo sistema.",
    inviteSentByEmail: "Convite enviado por email!",
    pendingInvites: "Convites pendentes",
    invitedAt: "Convidado em",
    expiresAt: "Expira em",
    resendInvite: "Reenviar convite",
    cancelInvite: "Cancelar convite",
    confirmCancelInvite: "Tem certeza que deseja cancelar o convite para {{email}}?",
    inviteCanceled: "Convite cancelado com sucesso",
    cancelInviteError: "Erro ao cancelar convite",
    inviteResent: "Convite reenviado por email",
    inviteRefreshed: "Convite atualizado! O usuario pode aceitar pelo sistema.",
    resendInviteError: "Erro ao reenviar convite",
    myInvites: "Meus convites",
    noInvites: "Voce nao possui convites pendentes",
    acceptInvite: "Aceitar convite",
    declineInvite: "Recusar convite",
    inviteFrom: "Convite de",
    inviteAccepted: "Convite aceito com sucesso!",
    acceptInviteError: "Erro ao aceitar convite",
    viewInvites: "Ver convites",
  },
  admin: {
    accessDenied: "Acesso negado. Permissao de administrador necessaria.",
    billingPlans: "Planos de Billing",
    billingPlansSubtitle: "Gerencie os planos de billing salvos no banco de dados. Voce pode sincronizar do Stripe e configurar limites e features.",
    plansList: "Planos cadastrados",
    noPlans: "Nenhum plano encontrado. Sincronize do Stripe para importar.",
    syncFromStripe: "Sincronizar do Stripe",
    syncSuccess: "{{count}} plano(s) sincronizado(s) com sucesso",
    syncError: "Erro ao sincronizar planos do Stripe",
    loadError: "Erro ao carregar planos",
    editPlan: "Editar plano",
    planName: "Nome",
    planPrice: "Preco (centavos)",
    pricePlaceholder: "Ex: 9900 para $99.00",
    priceHint: "Valor em centavos. Deixe vazio para gratuito.",
    planActive: "Status",
    active: "Ativo",
    inactive: "Inativo",
    configured: "Configurado",
    notConfigured: "Nao configurado",
    enabled: "Habilitado",
    disabled: "Desabilitado",
    unlimited: "Ilimitado",
    limitsTitle: "Limites",
    limitsHint: "Deixe vazio para ilimitado.",
    limitsSeats: "Membros",
    limitsProjects: "Projetos",
    limitsTestCases: "Casos de teste",
    limitsStorage: "Armazenamento (bytes)",
    limitsExecutions: "Execucoes",
    featuresTitle: "Features",
    featuresApiAccess: "Acesso API",
    featuresWebhooks: "Webhooks",
    featuresAuditLogs: "Audit logs (dias)",
    days: "{{count}} dias",
    nameRequired: "Nome e obrigatorio",
    saveSuccess: "Plano atualizado com sucesso",
    saveError: "Erro ao salvar plano",
    subscriptions: "Assinaturas",
    subscriptionsSubtitle: "Gerencie as assinaturas das organizacoes. Voce pode visualizar e alterar o plano de cada organizacao.",
    subscriptionsList: "Assinaturas cadastradas",
    noSubscriptions: "Nenhuma assinatura encontrada.",
    searchOrg: "Buscar organizacao...",
    changePlan: "Alterar plano",
    currentPlan: "Plano atual",
    newPlan: "Novo plano",
    planChangeSuccess: "Plano alterado com sucesso",
    planChangeError: "Erro ao alterar plano",
    periodStart: "Inicio",
    periodEnd: "Fim",
    cancelsAtEnd: "Cancela no fim do periodo",
  },
};

export default pt;
